import styled from '@emotion/styled';
import { mediaQuery, Spacings, Fonts } from '@styles/index';
import Image from '@base/Image';
import EllipsisGrid from '@icon/EllipsisGrid';
import { useIsMobile } from '@stores/AppCommonData';
import { REWARD_TYPES, REWARD_COLORS } from '../constants';

const Container = styled.div`
  padding: ${Spacings.SPACING_0B};
  gap: ${Spacings.SPACING_6B};
  order: 1;
  flex-grow: ${Spacings.SPACING_0B};
  ${mediaQuery.onlyTablet} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_2B};
    flex: none;
    overflow-x: auto;
    gap: ${Spacings.SPACING_3B};
  }
`;

const Panel = styled.div`
  position: relative;
  background-color: var(--color-base-1);
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${Spacings.SPACING_6B};
  gap: ${Spacings.SPACING_6B};
  border-radius: 11px;
  cursor: pointer;
  ${mediaQuery.uptoMobile} {
    width: 152px;
    flex: none;
    padding: ${Spacings.SPACING_4B} 14px;
    gap: ${Spacings.SPACING_4B};
  }
`;

const Rewardtext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.div`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.H4};
  color: var(--color-text-primary);
  ${mediaQuery.uptoMobile} {
    font-weight: ${Fonts.SEMIBOLD};
    font-size: ${Fonts.H6};
  }
`;

const SubLabel = styled.div`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.H5};
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H7};
    line-height: ${Fonts.LARGE};
  }
`;
const RewardDetailIcon = styled.div`
  position: relative;
  height: ${Spacings.SPACING_14B};
  width: ${({ $type }) =>
    $type === REWARD_TYPES.LAPTOP
      ? Spacings.SPACING_21B
      : Spacings.SPACING_14B};
  ${mediaQuery.uptoMobile} {
    height: ${Spacings.SPACING_10B};
    width: ${({ $type }) =>
      $type === REWARD_TYPES.LAPTOP
        ? Spacings.SPACING_15B
        : Spacings.SPACING_10B};
  }
`;

const RewardEllipseIcon = styled.div`
  position: absolute;
  right: ${Spacings.SPACING_1B};
  top: ${Spacings.SPACING_1B};
`;

const ReferralRewards = ({ referralRewards, isPaid, isWon, handleKowMore }) => {
  const isMobile = useIsMobile();
  return (
    <Container className="hero-reward-container">
      <Row>
        {referralRewards.map((reward) => {
          if (
            reward.type === REWARD_TYPES.TSHIRT ||
            reward.type === REWARD_TYPES.MOREREWARDS
          )
            return;
          if (reward.type === REWARD_TYPES.LAPTOP && (!isPaid || isWon)) return;
          return (
            <Panel
              key={reward.id}
              className="hero-reward-card"
              onClick={handleKowMore}
            >
              <RewardDetailIcon $type={reward.type}>
                <Image src={reward.icon} layout="fill" alt="reward" />
              </RewardDetailIcon>
              <RewardEllipseIcon>
                <EllipsisGrid
                  color={REWARD_COLORS[reward.type]}
                  width={isMobile ? 52 : 100}
                  height={isMobile ? 52 : 100}
                />
              </RewardEllipseIcon>
              <Rewardtext>
                <Label>{reward.label}</Label>
                <SubLabel color="var(--color-i-gray-13)">
                  {reward.subLabel}
                </SubLabel>
              </Rewardtext>
            </Panel>
          );
        })}
      </Row>
    </Container>
  );
};

export default ReferralRewards;
